module.exports = __webpack_public_path__ + "img/home-bg.b594455c.jpg";